(function() {
  'use strict';

  angular.module('ringbaPortal').component('userTaskListItem', {
    bindings: {
      task: '<',
    },
    controllerAs: 'vm',
    templateUrl: '/scripts/components/user-tasks/user-tasks-list/user-task-list-item/user-task-list-item.view.html'
  });
})();
